export default __webpack_public_path__ + "static/media/Phone.32bca8e5.png";